<section class="centered-hero" [ngClass]="background()" [appStoryblok]="_editable()" aria-labelledby="centered-hero-title">
  
    <div class="centered-hero-content">
      <div class="centered-hero-description">
        @if(badges()) {
            @for(badge of badges(); track badge._uid){
                <rds-badge
                [size]="badge.size"
                 [label]="badge.label"
                 [type]="badge.type"
                 [color]="badge.color">
             </rds-badge>
            }      
        }
        
        <h1 id="centered-hero-title" class="ui-heading-1-bold">{{title()}}</h1>
        <h2 class="ui-heading-2">{{subtitle()}}</h2>
        <p class="ui-body-l">{{paragraph()}}</p>
    
        
        @if(components) {
          <div class="buttons">
          @for(btn of buttons(); track btn._uid){
            
              @if (components[btn.component]) {
                <ndc-dynamic [ndcDynamicComponent]="components[btn.component]" [ndcDynamicInputs]="btn">
                </ndc-dynamic>
            } @else {
                <ndc-dynamic [ndcDynamicComponent]="components['notImplemented']" [ndcDynamicInputs]="btn">
                </ndc-dynamic>
            }
            
          }
          </div>
        }
       
        
        <div class="caption">
            <div class="licence">
                <span class="ui-label-m me-2">{{licenceCostLabel()}}</span>
                <span class="ui-label-m-bold">{{licenceCost()}}</span>
            </div>
            <div class="application-type">
                <span class="ui-label-m me-2">{{applicationTypeLabel()}}</span>
                <span class="ui-label-m-bold">{{applicationType()}}</span>
            </div>
        </div>
      </div>
    </div>
    
  </section>
  